import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { filledToggleGroupSx } from "@shared";

import { TakeoverView } from "@/pages/takeover/Takeover.types";
import { useTranslation } from "@/translations";

interface Props {
  value: TakeoverView;
  toTakeOverCount: number;
  onChange: (value: TakeoverView) => void;
}

export function TakeoverViewToggle({ value, toTakeOverCount, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      aria-label={t("takeover.view.toggleAriaLabel")}
      onChange={(_event, next: TakeoverView | null) => {
        if (next !== null) {
          onChange(next);
        }
      }}
      sx={filledToggleGroupSx}
    >
      <ToggleButton value="toTakeOver" sx={{ gap: 0.75 }}>
        {t("takeover.view.toTakeOver")}
        <Typography variant="caption" color="text.secondary">
          {toTakeOverCount}
        </Typography>
      </ToggleButton>
      <ToggleButton value="toRelease">{t("takeover.view.toRelease")}</ToggleButton>
    </ToggleButtonGroup>
  );
}
